import { render, staticRenderFns } from "./breeders-view.vue?vue&type=template&id=0720e905&scoped=true&lang=pug"
import script from "./breeders-view.js?vue&type=script&lang=js&external"
export * from "./breeders-view.js?vue&type=script&lang=js&external"
import style0 from "./breeders-view.vue?vue&type=style&index=0&id=0720e905&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0720e905",
  null
  
)

export default component.exports